import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { missingEnvVars } from './config';
import { getLocale } from './i18n';
import { ConfigError } from './components/ConfigError';

// Reflect the resolved UI language on <html> (index.html ships with lang="en").
// Subsequent switches are handled by setLocale in the i18n store.
document.documentElement.lang = getLocale();

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');
const root = createRoot(container);

if (missingEnvVars.length > 0) {
  // Missing/placeholder env → show what to set instead of a blank page.
  root.render(
    <StrictMode>
      <ConfigError missing={missingEnvVars} />
    </StrictMode>,
  );
} else {
  // Load the app (and Firebase init) lazily so any init failure is caught and
  // shown, rather than aborting module evaluation with an uncaught error.
  void import('./App')
    .then(({ App }) => {
      root.render(
        <StrictMode>
          <App />
        </StrictMode>,
      );
    })
    .catch((err: unknown) => {
      root.render(
        <StrictMode>
          <ConfigError detail={err instanceof Error ? err.message : String(err)} />
        </StrictMode>,
      );
    });
}
